import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getRefundStates} from '../services/getRefundStates';

export const useGetRefundStateQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.REFUND_STATES],
		queryFn: ({signal}) => getRefundStates({signal}),
		enabled: false,
	});
